/**
 * Info ("i") icon for the intermediate decline banner (PAS-32466).
 * White stroke on a transparent background — the yellow block colour
 * is provided by the surrounding CSS. Size controlled by CSS.
 * SVG sourced from the Figma design.
 */
export const InfoIcon = () => (
  <svg
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M11.75 11.75L11.8053 11.7223C12.5695 11.3403 13.4299 12.0305 13.2227 12.8593L12.2773 16.6407C12.0701 17.4695 12.9305 18.1597 13.6947 17.7777L13.75 17.75M24.75 12.75C24.75 19.3774 19.3774 24.75 12.75 24.75C6.12258 24.75 0.75 19.3774 0.75 12.75C0.75 6.12258 6.12258 0.75 12.75 0.75C19.3774 0.75 24.75 6.12258 24.75 12.75ZM12.75 7.75H12.76V7.76H12.75V7.75Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
